import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BasePage } from '@vitesse/base-ui/components/base-page';
import { t } from '@vitesse/base-ui/i18n';
import type { FindingsManager } from '../managers/findings-manager';
import type { FindingNames } from '../components/findings/finding-labels';
import '../components/findings/findings-list';

/*
 * <vitesse-findings> — the org's findings log: the page the agents call "the app's Findings view".
 *
 * ORG-WIDE, beside Flows in the tree's Workspace group, because what waits on a person spans every
 * relay: a proposal on one line and a re-measure due on another are one owner's morning. It opens
 * on Open — what is waiting on somebody — and the history is a tab away. A controller's own entries
 * are also on its page (the Findings tab there is this list, scoped to it); here a relay filter
 * narrows to one site.
 */
@customElement('vitesse-findings')
export class VitesseFindings extends BasePage {
  @property({ attribute: false }) manager?: FindingsManager;
  @property({ attribute: false }) names?: FindingNames;

  protected pageTitle(): string {
    return t('findings.title');
  }
  protected titleIcon(): string {
    return 'lightbulb';
  }
  protected renderDescription() {
    return t('findings.description');
  }
  protected aiHints(): string[] {
    return [t('findings.hintOpen'), t('findings.hintChanged')];
  }
  protected onBack(): void {
    this.dispatchEvent(new CustomEvent('navigate', { detail: { view: 'home' }, bubbles: true, composed: true }));
  }
  protected backLabel(): string {
    return t('findings.back');
  }
  protected renderContent() {
    return html`<vitesse-findings-list
      .manager=${this.manager}
      .names=${this.names}
      defaultTab="open"
      showFilters
    ></vitesse-findings-list>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'vitesse-findings': VitesseFindings;
  }
}
